import {createSelector} from "reselect";
import {initialState} from "./reducer";

/**
 * Direct selector to the orderPatientSearch state domain
 */

const selectOrderPatientSearchDomain = state =>
  state.get("orderPatientSearch", initialState);

/**
 * Other specific selectors
 */
const makeSelectOrderPatientPatients = () =>
  createSelector(selectOrderPatientSearchDomain, substate =>
    substate.get("patients").toJS(),
  );

const makeSelectOrderPatientPatientsTotal = () =>
  createSelector(selectOrderPatientSearchDomain, substate =>
    substate.get("total"),
  );

const makeSelectOrderPatientLoading = () =>
  createSelector(selectOrderPatientSearchDomain, substate =>
    substate.get("loading"),
  );

const makeSelectOrderPatientError = () =>
  createSelector(selectOrderPatientSearchDomain, substate =>
    substate.get("error"),
  );

/**
 * Default selector used by OrderPatientSearch
 */

const makeSelectOrderPatientSearch = () =>
  createSelector(selectOrderPatientSearchDomain, substate => substate.toJS());

export default makeSelectOrderPatientSearch;
export {
  selectOrderPatientSearchDomain,
  makeSelectOrderPatientPatients,
  makeSelectOrderPatientLoading,
  makeSelectOrderPatientError,
  makeSelectOrderPatientPatientsTotal,
};
